import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Call your backend API to send password reset email
      await api.post('/auth/forgot-password', { email: values.email });
      setEmailSent(true);
      message.success('Password reset link sent to your email!');
    } catch (error) {
      console.error('Error sending reset email:', error);
      message.error(error.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Title level={4}>Check Your Email</Title>
        <Text>
          We've sent a password reset link to your email address. 
          Please check your inbox and follow the instructions to reset your password.
        </Text>
        <div style={{ marginTop: '24px' }}>
          <Link to="/login">
            <Button type="primary">Back to Login</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '24px' }}>
        Forgot Password
      </Title>
      <Text style={{ display: 'block', marginBottom: '16px', textAlign: 'center' }}>
        Enter your email address and we'll send you a link to reset your password.
      </Text>
      
      <Form
        name="forgot_password"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email address' }
          ]}
        >
          <Input 
            prefix={<MailOutlined />} 
            placeholder="Email" 
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            size="large" 
            block
            loading={loading}
          >
            Send Reset Link
          </Button>
        </Form.Item>
      </Form>
      
      <div style={{ textAlign: 'center', marginTop: '16px' }}>
        <Text>Remember your password? </Text>
        <Link to="/login">Sign In</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
